import {
  GetAccountInfoRequest,
  GetAccountInfoResponse,
} from '@cbinsights/salesforceservice/salesforceservice';
import { request } from 'client/modules/common/utils/request';

export const getSalesforceAccountInfo = (
  req: Partial<GetAccountInfoRequest>
): Promise<GetAccountInfoResponse> =>
  request({
    url: '/service/salesforceservice/GetAccountInfo',
    body: req,
  }).then((r) => r.body);
